<template>
  <div>
    <div
      class="d-flex justify-content-between align-items-center mb-3 pb-3"
      :class="{ 'border-bottom': showHeading }">
      <component
        v-if="showHeading"
        :is="headingTag"
        class="mb-0">
        Cennik produktów
      </component>
      <div
        style="gap: 8px;"
        class="d-flex"
        :class="{ 'w-100 justify-content-end': !showHeading }">
        <d-button
          v-if="showLoadButton"
          @click.prevent="$emit('load-prices')"
          outline
          class="text-nowrap"
          :disabled="!loaded || loadError"
          theme="info">
          <i class="material-icons">download</i>
          Wczytaj cennik z&hellip;
        </d-button>
        <d-button
          @click.prevent="addProduct"
          outline
          class="text-nowrap"
          :disabled="!loaded || loadError"
          theme="success">
          <i class="material-icons">add</i>
          Dodaj produkt
        </d-button>
      </div>
    </div>

    <validation-observer
      ref="price-form"
      tag="form">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0 align-middle text-center"
              width="50">
              Lp.
            </th>
            <th
              scope="col"
              class="border-0 align-middle">
              Produkt
            </th>
            <th
              scope="col"
              class="border-0 align-middle">
              Cena
            </th>
            <th
              scope="col"
              class="border-0 align-middle text-center"
              width="75">
              Akcje
            </th>
          </tr>
        </thead>
        <tbody v-if="loaded && !loadError">
          <tr
            v-for="(row, index) in pricedProducts"
            :key="'product-cost-' + row._uid"
            ref="product-cost">
            <td class="align-middle text-center">
              {{ index + 1 }}
            </td>
            <td class="align-middle">
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  :filterBy="filterByName"
                  :disabled="row.saved === true"
                  class="productsForPrice"
                  :options="productsAvailable"
                  v-model="row.id"
                  :reduce="product => product.id"
                  :placeholder="'Wybierz produkt...'"
                  label="id">
                  <template
                    slot="option"
                    slot-scope="option">
                    {{ option.name }}
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="option">
                    {{ getProductName(row.id) }}
                  </template>
                  <template slot="no-options">Brak wyników</template>
                </v-select>
              </div>
            </td>
            <td
              class="align-middle"
              style="width: 200px">
              <validation-provider
                rules="required"
                name="cena"
                v-slot="{ errors }">
                <d-input-group>
                  <d-input
                    :class="{ 'is-invalid': errors.length }"
                    style="text-align: right;"
                    :step="0.01"
                    :min="0.0"
                    placeholder="0.00"
                    :state="errors.length ? 'invalid' : null"
                    type="number"
                    v-model="row.price"/>
                  <d-input-group-text slot="append">zł</d-input-group-text>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </d-input-group>
              </validation-provider>
            </td>
            <td class="align-middle text-center">
              <d-button
                :theme="'danger'"
                title="Usuń pozycję"
                @click.prevent="removeProduct(index)">
                <i
                  class="material-icons"
                  style="margin-left: 0.1rem;">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="pricedProducts.length === 0">
            <td
              colspan="4"
              class="text-center">
              Brak produktów do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>
    </validation-observer>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      Wczytywanie listy produktów nie powiodło się. <a
        href="javascript:window.location.reload();"
      class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
    </d-alert>

    <div
      v-else-if="!loaded"
      class="pb-3 pt-3 text-center">
      Trwa ładowanie danych&hellip;
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-price-table',
  props: {
    allProducts: {
      type: Array,
      required: true
    },
    loaded: {
      type: Boolean,
      default: true
    },
    loadError: {
      type: Boolean,
      default: false
    },
    showLoadButton: {
      type: Boolean,
      default: false
    },
    showHeading: {
      type: Boolean,
      default: true
    },
    headingTag: {
      type: String,
      default: 'h5'
    }
  },
  data () {
    return {
      pricedProducts: [],
      rowCounter: 0
    };
  },
  computed: {
    productsAvailable () {
      const selectedIds = this.pricedProducts.map(item => item.id).filter(id => id !== 0);
      return this.allProducts.filter(item => !selectedIds.includes(item.id));
    }
  },
  methods: {
    filterByName (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    getProductName (productId) {
      const product = this.allProducts.find(item => item.id === productId);
      return product ? product.name : '';
    },
    addProduct () {
      this.pricedProducts.push({
        _uid: ++this.rowCounter,
        id: 0,
        price: 0,
        saved: false
      });
    },
    removeProduct (index) {
      this.pricedProducts.splice(index, 1);
      if (!this.pricedProducts.length) {
        setTimeout(() => {
          this.addProduct();
        }, 500);
      }
    },
    setPrices (prices) {
      this.pricedProducts = prices.map(item => ({
        _uid: ++this.rowCounter,
        id: item.id,
        price: Number(item.price),
        saved: true
      }));
    },
    getPricedProducts () {
      return this.pricedProducts.length ? this.pricedProducts : [{ id: 0, price: 0 }];
    }
  }
};
</script>
